import React from "react";
import { Paper, Box } from "@mui/material";

const CustomCard = ({
    children,
    sx = {},
    boxSx = {},
    innerBoxSx = {}
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                my: 3,
                p: 3,
                borderRadius: "16px",
                border: "1px solid #e9ecef",
                backgroundColor: "white",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                "&:hover": {
                    boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
                    transform: "translateY(-4px)",
                    "& .filter-icon": { color: "#dc3545", transform: "rotate(360deg)" },
                },
                ...sx,
            }}
        >
            {/* Outer Box wrapper */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, ...boxSx }}>
                <Box sx={{ display: "flex", gap: 2, ...innerBoxSx }}>
                    {children}
                </Box>
            </Box>
        </Paper>
    );
};

export default CustomCard;
